
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import CollapseItem from '@/components/collapse.vue';
  import shoplist from "@/components/shoplist.vue";
  import chooseCoupon from "@/components/chooseCoupon.vue"
  import choosePrize from "@/components/choosePrize.vue"
  import uploadImg from "@/components/upload-img.vue"
	import Message from '@/components/message.vue';
  import {
    activityPayGiftactivityPayGiftInfo,
    activityPayGiftactivityPayGiftSave
  } from "@/api/live"
  @Component({  
    name: '',
    components: {
      PageFooter,
      CollapseItem,
      shoplist,
      chooseCoupon,
      uploadImg,
      choosePrize,
			'slz-message': Message,
    }
  })

  export default class ProductList extends Vue {
		private defaultThumb = 'https://cdn2024.shiwuzone.com/routuanapp/default-thumb.png';
    private pageloading = false
    private form:any = {
      Id:0,
      ActivityState:0,
      Name:'',
      StartTime:'',
      EndTime:'',
      ActivityDescription:'',
      JoinMemberType:[1],
      FullMoney:'',
      FullMoney2:'',
      ActivityRangeType:0,//0全部商品1指定商品
      ActivityRangeType2:0,//2参加//3不参加
      SpecifiedConditionType:null,
      SpecifiedConditionMoney:'',
      ActivityPayGiftProductList:[],
      EquityType:1,
      ActivityPayGiftEquityList:[],
      SendPrizeLimitPerDay:0,
      PaymentPromptImgUrl:[],
      prizeMsg:{},
      JoinMemberPurchasedSpecifiedProductList:[],
      IsEachFullSendCoupon:false,
    }
    private comparelist = [
      { value: 1, label: "等于" },
      { value: 2, label: "大于" },
      { value: 3, label: "大于或等于" },
      { value: 4, label: "小于" },
      { value: 5, label: "小于或等于" },
    ];
    private Iscondition = 0//1条件2商品
    private lastIscondition = 0
    private total = 0;
    private pageSize = 10;
    private pageNo = 1;
    private ActivityPayGiftProductList: any = [];
    private shopShow = false;
    private ActivityPayGiftEquityList:any = []
    private total2 = 0;
    private pageSize2 = 10;
    private pageNo2 = 1;
    private chooseShow = false
    private prizeShow = false
    private saveShow = false
    private appointShopShow = false
    private JoinMemberPurchasedSpecifiedProductList:any = []
    private total3 = 0;
    private pageSize3 = 10;
    private pageNo3 = 1;

    private mounted () {
      if(Number(this.$route.query.Id)){
        this.getInfo()
      }
    }

    private changeType(e){
      if(e!=1){
        this.form.IsEachFullSendCoupon = false
      }
    }
    private getAppointshop(list){
      if (!list || !list.length) {
        this.$message.error("请选择商品");
        return;
      }
      this.form.JoinMemberPurchasedSpecifiedProductList = list;
      this.appointShopShow = false
      this.getAppointShopList();
    }
    private delrow3(row) {
      this.form.JoinMemberPurchasedSpecifiedProductList = this.form.JoinMemberPurchasedSpecifiedProductList.filter((v) => {
        return v.Id != row.Id;
      });
      this.getAppointShopList();
    }
    private changePage3(e) {
      this.pageNo3 = e;
      this.getAppointShopList();
    }
    private getAppointShopList(){
      this.total3 = this.form.JoinMemberPurchasedSpecifiedProductList.length;
      this.JoinMemberPurchasedSpecifiedProductList = this.form.JoinMemberPurchasedSpecifiedProductList.filter((v, i) => {
        return (i >= (this.pageNo3 - 1) * this.pageSize3 &&i < this.pageNo3 * this.pageSize3);
      });
      if (this.pageNo3 > 1 && (!this.JoinMemberPurchasedSpecifiedProductList || !this.JoinMemberPurchasedSpecifiedProductList.length)) {
        this.pageNo3--;
        this.getAppointShopList();
      }
    }
    private async getInfo(){
      try{
        this.pageloading = true
        let res = await activityPayGiftactivityPayGiftInfo({
          ActivityPayGiftId:this.$route.query.Id
        })
        if(res.IsSuccess){
          let form = res.Result
          form.Id = this.$route.query.Id
          if(form.ActivityRangeType==0){
            form.ActivityRangeType2 = 0
            form.SpecifiedConditionType = form.SpecifiedConditionType||null
            form.SpecifiedConditionMoney = form.SpecifiedConditionMoney||''
          }else if(form.ActivityRangeType==1){
            form.FullMoney2 = form.FullMoney
            form.FullMoney = ''
            form.ActivityRangeType2 = 2
            this.Iscondition = 1
            this.lastIscondition = 1
          }else{
            if(form.ActivityRangeType==2){
              form.ActivityRangeType2 = 2
              this.Iscondition = 2
              this.lastIscondition = 2
            }else if(form.ActivityRangeType==3){
              form.ActivityRangeType2 = 3
              this.Iscondition = 1
              this.lastIscondition = 1
            }else if(form.ActivityRangeType==4){
              form.ActivityRangeType2 = 3
              this.Iscondition = 2
              this.lastIscondition = 2
            }
            form.FullMoney2 = form.FullMoney
            form.FullMoney = ''
            form.ActivityRangeType = 1
            form.SpecifiedConditionType = form.SpecifiedConditionType||null
            form.SpecifiedConditionMoney = form.SpecifiedConditionMoney||''
          }
          // console.log(this.Iscondition)
          if(this.Iscondition==2){
            form.ActivityPayGiftProductList = form.ActivityPayGiftProductList.map(v=>{
              return {
                ...v,
                ImgUrlComplete:v.MainImgUrlComplete,
                Id:v.ProductId
              }
            })
          }


          if(form.EquityType==2){
            form.prizeMsg = form.ActivityPayGiftEquityList[0]
            form.ActivityPayGiftEquityList = []
          }else{
            form.prizeMsg = {}
            form.ActivityPayGiftEquityList = form.ActivityPayGiftEquityList.map(v=>{
              return {
                ...v,
                CouponName:v.Name
              }
            })
          }
          if(form.JoinMemberPurchasedSpecifiedProductList.length){
            this.JoinMemberPurchasedSpecifiedProductList = form.JoinMemberPurchasedSpecifiedProductList.map(v=>{
              v.Id = v.ProductId
              return v
            })
          }
          form.PaymentPromptImgUrl = [form.PaymentPromptImgUrl]
          this.form = JSON.parse(JSON.stringify(form))
          this.getActivityPayGiftEquityList()
          this.getActivityPayGiftProductList()
          this.getAppointShopList()
          // console.log(this.form)
        }
      }finally{
        this.pageloading = false
      }
    }
    private async confirmSave(){
      try{
        this.pageloading = true
        let form = JSON.parse(JSON.stringify(this.form))
        if(form.ActivityRangeType==1){
          if(form.ActivityRangeType2==2){
            form.ActivityRangeType = this.Iscondition==1?1:2
          }else{
            form.ActivityRangeType = this.Iscondition==1?3:4
          }
        }
        if(form.ActivityRangeType==0){
          form.SpecifiedConditionType = ''
          form.SpecifiedConditionMoney = ''
          form.ActivityPayGiftProductList = []
        }else{
          form.FullMoney = form.FullMoney2
          if(form.ActivityRangeType==1||form.ActivityRangeType==3){
            form.ActivityPayGiftProductList = []
          }else if(form.ActivityRangeType==2||form.ActivityRangeType==4){
            form.SpecifiedConditionType = ''
            form.SpecifiedConditionMoney = ''
            form.ProductIdList = form.ActivityPayGiftProductList.map(v=>v.Id)
          }
        }

        delete form.ActivityRangeType2
        delete form.FullMoney2
        delete form.ActivityPayGiftProductList
        if(form.EquityType==1){
          form.SendPrizeLimitPerDay = 0
        }else{
          form.ActivityPayGiftEquityList = [{
            ...form.prizeMsg,
            SendCount:1
          }]
        }
        form.ActivityPayGiftEquityList = form.ActivityPayGiftEquityList.map(v=>{
          return {
            RelationId:v.Id,
            SendCount:v.SendCount
          }
        })
        delete form.prizeMsg
        form.JoinMemberPurchasedSpecifiedProductIdList = form.JoinMemberPurchasedSpecifiedProductList.map(v=>v.Id)
        delete form.JoinMemberPurchasedSpecifiedProductList
        form.PaymentPromptImgUrl = form.PaymentPromptImgUrl[0]
        let res:any = await activityPayGiftactivityPayGiftSave(form)
        if(res.IsSuccess){
          this.$message.success('保存成功')
          this.$router.go(-1)
        }
      }finally{
        this.pageloading = false
      }
    }
    private tosave(){
      let two = /^\d+(\.\d{1,2})?$/
      if(!this.form.Name){
        this.$message.error('请输入活动名称')
        return 
      }
      if(!this.form.StartTime||!this.form.EndTime){
        this.$message.error('请完善活动时间')
        return 
      }
      if(new Date(this.form.StartTime).getTime()>new Date(this.form.EndTime).getTime()){
        this.$message.error('开始时间不能晚于结束时间')
        return 
      }
      if(!this.form.ActivityDescription){
        this.$message.error('请填写活动说明，方便用户更好了解活动细则')
        return 
      }
      if(!this.form.JoinMemberType||!this.form.JoinMemberType.length){
        this.$message.error('请选择参与人群')
        return 
      }
      if(this.form.JoinMemberType.some(v=>v==3)&&(!this.form.JoinMemberPurchasedSpecifiedProductList||!this.form.JoinMemberPurchasedSpecifiedProductList.length)){
        this.$message.error('购买指定商品为空，请补充')
        return 
      }
      if(this.form.ActivityRangeType==0&&!this.form.FullMoney){
        this.$message.error('请输入单笔订单满足金额')
        return 
      }
      if(this.form.ActivityRangeType!=0&&!this.form.FullMoney2){
        this.$message.error('请输入单笔订单满足金额')
        return 
      }
      if(this.form.ActivityRangeType==1){
        if(!this.Iscondition){
          this.$message.error("请设置参与条件或指定商品");
          return;
        }
        if(this.Iscondition==1){
          if(!this.form.SpecifiedConditionType){
            this.$message.error("请选择条件类型");
            return;
          }
          if(this.form.SpecifiedConditionMoney < 0.01 ||this.form.SpecifiedConditionMoney > 999999.99 || !two.test(this.form.SpecifiedConditionMoney)){
            this.$message.error("团购价金额异常，允许0.01~999999.99");
            return;
          }
        }else{
          if(!this.form.ActivityPayGiftProductList ||!this.form.ActivityPayGiftProductList.length){
            this.$message.error("请设置指定商品");
            return;
          }
        }
      }
      if(this.form.EquityType==1){
        if(!this.form.ActivityPayGiftEquityList||!this.form.ActivityPayGiftEquityList.length){
          this.$message.error('请选择要赠送的优惠券')
          return 
        }
        for(let item of this.form.ActivityPayGiftEquityList){
          if(item.SendCount<1||item.SendCount>100){
            this.$message.error('赠送数量请控制在1~100的数值')
            return
          }
        }
      }else{
        if(!this.form.prizeMsg||!this.form.prizeMsg.Id){
          this.$message.error('请选择抽奖活动')
          return 
        }
        if(String(this.form.SendPrizeLimitPerDay)==''){
          this.$message.error('请设置单个id每天最多赠送的抽奖机会')
          return 
        }
        if(this.form.SendPrizeLimitPerDay<0||this.form.SendPrizeLimitPerDay>10000){
          this.$message.error('单个Id最多赠送抽奖机会允许0~10000')
          return 
        }
      }
      if(!this.form.PaymentPromptImgUrl||!this.form.PaymentPromptImgUrl.length){
        this.$message.error('请设置支付后提示图')
          return 
      }
      this.saveShow = true
    }

    private getPrize(e){
      this.form.prizeMsg = e
      if(this.form.ActivityState==0){
        this.form.EquityType = 2
      }
      this.prizeShow = false
    }
    private uploadSuc(file,key){
      this.form[key] = file
    }
    private blurSend(e,row){
      if(row.SendCount<1||row.SendCount>100||row.SendCount!=parseInt(row.SendCount)){
        this.$message.error('赠送数量请控制在1~100的数值')
        this.form.ActivityPayGiftEquityList = this.form.ActivityPayGiftEquityList.map(v=>{
          if(row.Id==v.Id){
            row.SendCount = ''
          }
          return v
        })
        this.getActivityPayGiftEquityList();
        return 
      }
    }
    private getData(list){
      if(!list||!list.length){
        this.$message.error('请选择要赠送的优惠券')
        return
      }
      this.form.ActivityPayGiftEquityList = JSON.parse(JSON.stringify(list)).map(v=>{
        v.SendCount = ''
        let old = this.form.ActivityPayGiftEquityList.find(x=>x.Id==v.Id)
        if(old&&old.Id){
          v.SendCount = old.SendCount
        }
        return v
      });
      this.chooseShow = false
      this.getActivityPayGiftEquityList();
    }
    private delrow2(row) {
      this.form.ActivityPayGiftEquityList = this.form.ActivityPayGiftEquityList.filter((v) => {
        return v.Id != row.Id;
      });
      this.getActivityPayGiftEquityList();
    }
    private changePage2(e){
      this.pageNo2 = e;
      this.getActivityPayGiftEquityList();
    }
    private getActivityPayGiftEquityList(){
      this.total2 = this.form.ActivityPayGiftEquityList.length;
      this.ActivityPayGiftEquityList = this.form.ActivityPayGiftEquityList.filter((v, i) => {
        return (i >= (this.pageNo2 - 1) * this.pageSize2 &&i < this.pageNo2 * this.pageSize2);
      });
      // console.log(this.ActivityPayGiftProductList)
      if (this.pageNo2 > 1 && (!this.ActivityPayGiftEquityList || !this.ActivityPayGiftEquityList.length)) {
        this.pageNo2--;
        this.getActivityPayGiftEquityList();
      }
    }

    private delrow(row) {
      this.form.ActivityPayGiftProductList = this.form.ActivityPayGiftProductList.filter((v) => {
        return v.Id != row.Id;
      });
      this.getActivityPayGiftProductList();
    }
    private getshop(list) {
      if (!list || !list.length) {
        this.$message.error("请选择商品");
        return;
      }
      this.form.ActivityPayGiftProductList = list;
      this.shopShow = false;
      this.Iscondition = 2
      this.lastIscondition = 2
      this.getActivityPayGiftProductList();
    }
    private changePage(e) {
      this.pageNo = e;
      this.getActivityPayGiftProductList();
    }
    private getActivityPayGiftProductList() {
      this.total = this.form.ActivityPayGiftProductList.length;
      this.ActivityPayGiftProductList = this.form.ActivityPayGiftProductList.filter((v, i) => {
        return (i >= (this.pageNo - 1) * this.pageSize &&i < this.pageNo * this.pageSize);
      });
      if (this.pageNo > 1 && (!this.ActivityPayGiftProductList || !this.ActivityPayGiftProductList.length)) {
        this.pageNo--;
        this.getActivityPayGiftProductList();
      }
    }
    private falseCheck(e){
      if(e==0){
        this.Iscondition = this.lastIscondition
      }

      this.lastIscondition = e
    }
    private changeApplicablegoods(e){
      this.form.ActivityRangeType2 = this.form.ActivityRangeType2==0?2:this.form.ActivityRangeType2
      // console.log(e)
      if(e==1){
        this.Iscondition = this.Iscondition==0?1:this.Iscondition
        this.lastIscondition = this.lastIscondition==0?1:this.lastIscondition
      }
      // console.log(this.form.ActivityRangeType,this.form.ActivityRangeType2,this.Iscondition)
    }
  }
